import React from "react";

const QuoteBlock = ({ quote, author }) => {
  return (
    <div className="relative border-l-4 border-mmAccent pl-6 md:pl-10 my-20 pr-4 py-6 bg-mmSurface rounded-2xl border border-mmBorder shadow-sm transition-all hover:shadow-md duration-300 max-w-4xl mx-auto group">
      <p className="text-mmTextMuted text-base md:text-lg italic leading-relaxed">
        “{quote}”
      </p>
      <p className="font-display uppercase tracking-widest mt-4 text-left group-hover:translate-x-1 transition-transform duration-300 text-base md:text-lg text-mmAccent">
        - {author}
      </p>

      {/* Glowing accent */}
      <span className="absolute top-0 left-0 w-1 h-full bg-mmAccent" />
    </div>
  );
};

export default QuoteBlock;

/* <section className="py-20 bg-mmPage">
  <h2 className="mm-h2 text-center mb-10 text-mmText">
    Words to Live By
  </h2>
  <div className="space-y-16">
    <QuoteBlock
      quote="The only easy day was yesterday."
      author="Navy SEAL Motto"
    />
     <QuoteBlock
      quote="Hard times don’t build character. They reveal it."
      author="Justin Peeters"
    />
    <QuoteBlock
      quote="Discipline is choosing between what you want now and what you want most."
      author="Abraham Lincoln"
    />
    <QuoteBlock
      quote="Courage is not the absence of fear, but the triumph over it."
      author="Nelson Mandela"
    />
  </div>
</section> */
